export default __webpack_public_path__ + "static/media/prev-IVTS-1.cdee3f44.png";